import React, { Component, Fragment } from 'react';
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';
export class MapContainer extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            latitude:"",
            longitude:"",
            enabled: false

         }
         this.getLocation = this.componentDidMount.bind(this)
         this.getLocation = this.getLocation.bind(this)
         this.getCoordinates = this.getCoordinates.bind(this)
    }
componentDidMount() {
  if(navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(this.getCoordinates)
    this.setState({
      enabled: true
     })
} else {
    alert('Unable to access your coordinates.')
}

}
    getLocation() {
        if(navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(this.getCoordinates)
        } else {
            alert('Unable to access your coordinates st this time. Please enable access location to use')
        }
    }

    getCoordinates(position) {
       this.setState({
         latitude:   position.coords.latitude,
         longitude:   position.coords.longitude
        })
        localStorage.setItem('latitude',  position.coords.latitude)
        localStorage.setItem('longitude',  position.coords.longitude)
    }
  render() {
    const mapStyles = {
        width: '96%',
        height: '200px',  
        position: 'absolute', 
        borderRadius:"20px",
        zIndex:"1",
      };
    const latitude =  localStorage.getItem('latitude');
    const longitude =  localStorage.getItem('longitude');
    return (
      <Fragment>
      <Map
      google={this.props.google}
      zoom={16}
      style={mapStyles}
      initialCenter={{
        lat: latitude,
        lng: longitude
      }}
      >
     <button className="button" onClick={this.getLocation}>Find / Update my Location</button> 
      <Marker position={{ lat: latitude, lng: longitude}}/>
      </Map>
      </Fragment>
      


    );
  }
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyDP_7k3QlxgVxo-c8hM4g14lDJlrv59oXQ'
})(MapContainer);